import { Link as ReactRouterLink } from 'react-router-dom';
import { Text, Link as ChakraLink, Box } from '@chakra-ui/react';
import PublishTag from 'components/common/fields/PublishTag';
import EmailGroup from 'components/common/fields/EmailGroup';
import AccessTag from 'components/common/fields/AccessTag';

export default [
  {
    name: 'Id',
    selector: (row) => row.id,
    sortable: true,
    width: '60px',
    sortField: 'id',
  },
  {
    name: 'Name',
    selector: (row) => row.name,
    sortable: true,
    cell: (row) => (
      <ChakraLink
        as={ReactRouterLink}
        color="blue.500"
        to={`/admin/courses/${row.id}`}
      >
        <Text fontWeight={500} as="i">
          {row.name}
        </Text>
      </ChakraLink>
    ),
    sortField: 'name',
  },
  {
    name: 'Category',
    selector: (row) => row.category.name,
    sortable: true,
    sortField: 'category',
  },
  {
    name: 'Code',
    selector: (row) => row.code,
    sortable: true,
    cell: (row) => <Text as="b"> {row.code || 'N/A'}</Text>,
    sortField: 'code',
  },
  {
    name: 'Owner',
    selector: (row) => row.owner.name,
    sortable: true,
    cell: (row) => (
      <Box py={2}>
        <Text fontWeight={500} mb={2}>
          {row.owner?.name || 'N/A'}
        </Text>
        <EmailGroup name="Owner Groups:" emails={row.ownerGroups} />
      </Box>
    ),
    sortField: 'owner',
  },
  {
    name: 'Status',
    selector: (row) => row.isPublished,
    sortable: true,
    cell: (row) => <PublishTag isPublished={row.isPublished} />,
    sortField: 'isPublished',
  },
  {
    name: 'Access',
    selector: (row) => row.isPrivate,
    sortable: true,
    cell: (row) => <AccessTag isPrivate={row.isPrivate} />,
    sortField: 'isPrivate',
  },
];
